import { useOidcContext } from '../contexts/OidcContext';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import LogoutIcon from '@mui/icons-material/Logout';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import { XxllncAiLogo, McpIcon } from '../components/icons';
import { useBranding } from '../contexts/BrandingContext';
import { useTranslation } from '../i18n/useTranslation';

export default function PendingPage() {
  const { logout } = useOidcContext();
  const t = useTranslation();
  const branding = useBranding();
  const portalTitle = branding.portal_title || 'MCP Hub';

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: 'background.default',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* Header */}
      <Box
        sx={{
          bgcolor: '#fff',
          borderBottom: '1px solid rgba(0,0,0,0.07)',
          px: 4,
          py: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          {branding.logo_url ? (
            <Box
              component="img"
              src={branding.logo_url}
              alt="logo"
              sx={{ maxHeight: '2rem', maxWidth: 160, width: 'auto' }}
            />
          ) : (
            <XxllncAiLogo height={24} />
          )}
          <Box sx={{ width: '1px', height: 20, bgcolor: 'rgba(0,0,0,0.1)', mx: 0.5 }} />
          <McpIcon sx={{ fontSize: 16, color: 'text.primary' }} />
          <Typography sx={{ fontWeight: 700, fontSize: '0.875rem', color: 'text.primary', letterSpacing: '-0.01em' }}>
            {portalTitle}
          </Typography>
        </Box>
        <Tooltip title={t('common.logoutTooltip')}>
          <IconButton
            onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
            size="small"
            sx={{ color: 'text.disabled' }}
          >
            <LogoutIcon sx={{ fontSize: 18 }} />
          </IconButton>
        </Tooltip>
      </Box>

      {/* Content */}
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 3,
          py: 8,
        }}
      >
        <Box sx={{ maxWidth: 480, width: '100%', textAlign: 'center' }}>
          {/* Icon */}
          <Box
            sx={{
              width: 72,
              height: 72,
              borderRadius: '20px',
              bgcolor: 'action.hover',
              border: '1px solid rgba(0,0,0,0.08)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mx: 'auto',
              mb: 4,
            }}
          >
            <HourglassTopIcon sx={{ fontSize: 32, color: 'text.disabled' }} />
          </Box>

          <Typography
            sx={{
              fontSize: '1.75rem',
              fontWeight: 800,
              letterSpacing: '-0.03em',
              color: 'text.primary',
              lineHeight: 1.2,
              mb: 2,
            }}
          >
            {t('pending.title')}
          </Typography>

          <Typography
            sx={{
              fontSize: '0.95rem',
              color: 'text.secondary',
              lineHeight: 1.7,
              mb: 5,
            }}
          >
            {t('pending.body')}
          </Typography>

          <Button
            variant="outlined"
            onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
            sx={{
              borderColor: 'rgba(0,0,0,0.15)',
              color: 'text.secondary',
              fontWeight: 600,
              borderRadius: '10px',
              textTransform: 'none',
              px: 3,
              '&:hover': { borderColor: 'text.primary', color: 'text.primary', bgcolor: 'transparent' },
            }}
          >
            {t('common.logout')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
